import { defineComponent as _defineComponent } from 'vue'
import { THGPresignedUrl } from '@/interfaces/thg/THGPresignedUrl';
    import { computed, ref } from 'vue';
    import { Country } from '@/enums/Country';
    import { useTHGGlobalStore } from '@/storenew/thg/global';
    import { THGCar } from '@/interfaces/thg/THGCar';
    import EditTHGCarVRCModal from '@/components/thg/cars/EditTHGCarVRCModal.vue';
    import emitter from '@/utils/mitt';
    import { getPresignedUrl, replace } from '@/api/thg/vrc';
    import { toBase64 } from '@/utils/files';
    import { ToastProgrammatic as Toast } from 'buefy';

    interface Props {
        car: THGCar;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'EditTHGCarVRCs',
  props: {
    car: null
  },
  setup(__props: any) {

const props = __props as {
        car: THGCar;
    };

    const { currentCountry } = useTHGGlobalStore();

    

    const newFrontFile = ref<File | undefined>();
    const newBackFile = ref<File | undefined>();

    const showFrontEdit = ref<boolean>(false);
    const showBackEdit = ref<boolean>(false);

    async function replaceVRC(newFile: File, oldFileName: string) {
        emitter.emit('showLoader');

        if (!props.car._id) {
            throw new Error('Car ID is undefined.');
        }

        showFrontEdit.value = false;
        showBackEdit.value = false;

        const base64File = await toBase64(newFile, false);
        const resp = await replace({
            car_id: props.car._id,
            new_vrc_file: base64File,
            old_vrc_filename: oldFileName,
        });

        if (!resp.parsedBody) {
            throw new Error('Error while replacing vrc');
        }

        emitter.emit('hideLoader');
        Toast.open({ type: 'is-success', message: 'Zulassungsschein wurde erfolgreich ersetzt.' });
    }

    async function onFrontFileReplace(value: File) {
        if (!props.car.vrc_front_file) {
            throw new Error('VRC front file is undefined');
        }

        await replaceVRC(value, props.car.vrc_front_file);
    }

    async function onBackFileReplace(value: File) {
        if (!props.car.vrc_back_file) {
            throw new Error('VRC back file is undefined.');
        }

        await replaceVRC(value, props.car.vrc_back_file);
    }

    async function vrcFileOpen(fileKey: string) {
        // wait for the presigned url to be generated and retrieved
        const urlResp = await getPresignedVrcUrl(fileKey);

        // open a new window with url as resource
        window.open(urlResp.url, '_blank');
    }

    /**
     * Wrapper to call the getPresignedUrl endpoint.
     *
     * @param fileKey
     * @return preSignedUrl Response
     */
    async function getPresignedVrcUrl(fileKey: string): Promise<THGPresignedUrl> {
        const res = await getPresignedUrl(fileKey);

        if (!res.parsedBody) {
            throw new Error('cannot retrieve vrc presigned url');
        }

        return res.parsedBody;
    }

    const frontFileLabel = computed<string>(() => {
        if (currentCountry === Country.AT) {
            return 'Zulassungsschein Vorderseite (Deckblatt)';
        }

        return 'Zulassungsschein Vorderseite';
    });

    const backFileLabel = computed<string>(() => {
        if (currentCountry === Country.AT) {
            return 'Zulassungsschein Rückseite (Daten)';
        }

        return 'Zulassungsschein Rückseite';
    });

return { __sfc: true,currentCountry, props, newFrontFile, newBackFile, showFrontEdit, showBackEdit, replaceVRC, onFrontFileReplace, onBackFileReplace, vrcFileOpen, getPresignedVrcUrl, frontFileLabel, backFileLabel, EditTHGCarVRCModal }
}

})